import type { CustomVendorCategory } from '@/types';

export const DEFAULT_CATEGORY_ICON = 'sparkles';

// custom_vendor_categories is a Postgres text[], so each category is stored as a
// JSON-encoded string ('{"name":"...","icon":"..."}'). Entries written before
// icons existed are plain names and fall back to the default icon.
export function parseCustomVendorCategory(raw: unknown): CustomVendorCategory {
  if (typeof raw !== 'string') return { name: String(raw), icon: DEFAULT_CATEGORY_ICON };
  try {
    const parsed = JSON.parse(raw);
    if (parsed && typeof parsed === 'object' && typeof parsed.name === 'string') {
      return { name: parsed.name, icon: typeof parsed.icon === 'string' ? parsed.icon : DEFAULT_CATEGORY_ICON };
    }
  } catch {
    // plain-string legacy entry
  }
  return { name: raw, icon: DEFAULT_CATEGORY_ICON };
}

export function serializeCustomVendorCategory(category: CustomVendorCategory): string {
  return JSON.stringify({ name: category.name, icon: category.icon });
}
